export default __webpack_public_path__ + "static/media/storyfour.4374220e.mp4";